import { useContext, useState } from 'react';
// import * as functions from "./ButtonsFunctions"; // funkcije svih dugmica
import { TabContext } from '../../../Context/TabContext';
import './Buttons.css';
import { isMobile } from '../../../../utils/isMobile';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Buttons(props) {
  const { t, i18n } = useTranslation();
  const tabContext = useContext(TabContext);
  const [open, setOpen] = useState(false);
  const btnsArray = [
    {
      id: 1,
      title: 'Osveži',
      icon: 'fas fa-sync',
      components: [3, 4], // niz oznacava na kojim se sve komponentama dugme prikazuje (brojevi su id-evi odnosno type komponente)
    },

    {
      id: 3,
      title: t('buttons.save'),
      icon: 'fas fa-save',
      components: [
        3, 4, 5, 19, 20, 24, 26, 27, 25, 29, 28, 30, 33, 34, 36, 37, 35, 38, 40,
        41, 42, 43, 44, 45, 15, 10005, 55, 10006, 54, 60, 61, 64, 10008, 1065,
        10009, 1066, 10007, 1067, 1068, 1069, 1071, 1074, 1075, 1076, 2083,
        2086, 2087, 2090, 2096, 2098, 2100, 10010, 69, 72, 73, 10012, 10013,
        10022, 1080, 1082,
      ],
      // function: props.sendRequest,
      disabled:
        props.disableBtn.disabled &&
        props.disableBtn.id === tabContext.activeComponent,
    },
    {
      id: 2,
      title: t('buttons.addNew'),
      icon: 'fas fa-plus',
      components: [
        20, 26, 24, 25, 27, 29, 28, 30, 33, 34, 36, 37, 35, 38, 40, 41, 42, 43,
        44, 45, 49, 15, 51, 10005, 52, 55, 53, 10006, 60, 61, 59, 64, 1062,
        10008, 1063, 62, 10007, 1065, 10009, 1066, 1067, 1068, 1069, 1071, 1075,
        1076, 1073, 1074, 2083, 2086, 2087, 2090, 2096, 2098, 2100, 69, 70, 72,
        74, 73, 75, 10013, 1077, 1080, 1082,
      ],
      disabled:
        props.disableBtnNovi.disabled &&
        props.disableBtnNovi.id === tabContext.activeComponent,
    },

    {
      id: 4,
      title: 'Obriši',
      icon: 'fas fa-trash-alt',
      components: [],
      disabled:
        props.disableBtn.disabled &&
        props.disableBtn.id === tabContext.activeComponent,
    },

    {
      id: 5,
      title: 'Štampa',
      icon: 'fas fa-print',
      components: [1085],
    },

    {
      id: 6,
      title: 'Info',
      icon: 'far fa-question-circle',
      components: [],
    },
    {
      id: 7,
      title: 'Deklaracije',
      icon: 'far fa-window-maximize',
      components: [9],
      disabled: props.disableDeklaracije,
    },
    {
      id: 20,
      title: 'Osveži',
      icon: 'fas fa-sync',
      components: [19],
    },
    {
      id: 21,
      title: 'Dodaj logo',
      icon: 'fas fa-plus',
      components: [15],
      disabled: props.disableLogo,
    },

    {
      id: 23,
      title: 'Dodaj stavku za pakovanje',
      icon: 'fas fa-plus',
      components: [],
      disabled: props.disableStavka,
    },
    {
      id: 27,
      title: 'Prikaži sve',
      icon: 'fas fa-eye',
      components: [53],
    },
    {
      id: 28,
      title: 'Matrica veština',
      icon: 'fas fa-cubes',
      components: [61],
      disabled: props.disableMatricaVestina,
    },
    {
      id: 29,
      title: 'Matrica zapisa ocenjivanja',
      icon: 'fas fa-cubes',
      components: [61],
      disabled: props.disableMatricaZapisa,
    },
    {
      id: 33,
      title: 'Izmena plana',
      icon: 'fas fa-edit',
      components: [],
      disabled: props.disableIzmenaPlana,
    },
    {
      id: 30,
      title: 'Pregled plana',
      icon: 'fas fa-eye',
      components: [],
      disabled: props.disablePregledPlana,
    },
    {
      id: 31,
      title: 'Mesečni plan',
      icon: 'fas fa-calendar',
      components: [],
      disabled: props.disableMesecniPlan,
    },
    {
      id: 32,
      title: 'Ostvareni plan',
      icon: 'fas fa-check',
      components: [],
      disabled: props.disableOstvareniPlan,
    },
    {
      id: 34,
      title: 'Izvršene posete',
      icon: 'fas fa-check-double',
      components: [],
      disabled: props.disablePlanPoseta,
    },
    {
      id: 22,
      title: 'Promena statusa',
      icon: 'fas fa-check-circle',
      components: [],
      disabled: props.disablePromenaStatusa,
    },
    {
      id: 35,
      title: 'Dodaj atribut',
      icon: 'fas fa-file',
      components: [55, 10009],
      disabled: props.disableDodajAtribut,
    },
    {
      id: 36,
      title: t('buttons.send'),
      icon: 'fas fa-paper-plane',
      components: [10010],
      disabled: props.disablePosalji,
    },
    {
      id: 37,
      title: t('newRobotMold'),
      icon: 'fas fa-plus',
      components: [68],
      disabled:
        props.disableBtnNovaMasina.disabled &&
        props.disableBtnNovaMasina.id === tabContext.activeComponent,
    },
    {
      id: 38,
      title: 'Radni nalog',
      icon: 'fas fa-pen',
      components: [10014],
      disabled: localStorage.idFirme !== '1',
    },
    {
      id: 39,
      title: 'Shop',
      icon: 'fa fa-shopping-cart',
      components: [1072],
      broj: props.dataNumberOfArticles,
    },
    {
      id: 40,
      title: t('buttons.detail'),
      icon: 'fas fa-info',
      components: [10012, 10022],
      disabled: props.disableDetail,
    },
    {
      id: 41,
      title: 'Dodeli zaposlenima',
      icon: 'fas fa-user-plus',
      components: [10012, 10022],
      disabled: props.disableDodeliZaposlenima,
    },
    {
      id: 42,
      title: 'Dnevnik',
      icon: 'fas fa-book',
      components: [10012, 10022],
      // disabled: props.disableDetail,
    },
    {
      id: 43,
      title: 'Beleške',
      icon: 'fas fa-book',
      components: [10022],
      // disabled: props.disableDetail,
    },
    {
      id: 44,
      title: 'Izveštaji',
      icon: 'fas fa-file-alt',
      components: [10022],
      // disabled: props.disableDetail,
    },
    {
      id: 45,
      title: t('document'),
      icon: 'fas fa-file',
      components: [10012],
      disabled:
        props.disableKreirajDokument.disabled &&
        props.disableKreirajDokument.id === tabContext.activeComponent,
    },
    ...(localStorage.uniqueUser === 'true'
      ? [
          {
            id: 46,
            title: t('pdfReport'),
            icon: 'fas fa-file-pdf',
            components: [10012 /* , 10022 */],
            disabled: props.disableDodeliZaposlenima,
          },
        ]
      : []),
  ];

  // filter funkcijom izvlačimo sve dugmice iz niza u kojima se nalazi aktivni tab (komponenta)
  const buttons = btnsArray.filter(
    (item) => item.components.indexOf(+tabContext.activeComponent) > -1,
  );

  const handleClick = (item) => {
    if (item.id === 1) {
      props.sendRequest(props.refreshData);
    } else if (item.id === 2) {
      props.handleNovi(true);
    } else if (item.id === 3) {
      props.handleSave(true);
    } else if (item.id === 4) {
      props.handleObrisiDok(true);
    } else if (item.id === 5) {
      props.handleStampa(true);
    } else if (item.id === 6) {
      props.handleInfo(true);
    } else if (item.id === 7) {
      props.handleDeklaracije(true);
    } else if (item.id === 20) {
      props.handleOsvezi(true);
    } else if (item.id === 21) {
      props.handleLogo(true);
    } else if (item.id === 22) {
      props.handlePromenaStatusa(true);
    } else if (item.id === 23) {
      props.handleStavka(true);
    } else if (item.id === 27) {
      props.handlePrikaziSve(true);
    } else if (item.id === 28) {
      props.handleMatricaVestina(true);
    } else if (item.id === 29) {
      props.handleMatricaZapisa(true);
    } else if (item.id === 30) {
      props.handlePregledPlana(true);
    } else if (item.id === 31) {
      props.handleMesecniPlan(true);
    } else if (item.id === 32) {
      props.handleOstvareniPlan(true);
    } else if (item.id === 33) {
      props.handleIzmenaPlana(true);
    } else if (item.id === 34) {
      props.handlePlanPoseta(true);
    } else if (item.id === 35) {
      props.handleDodajAtribut(true);
    } else if (item.id === 36) {
      props.handlePosalji(true);
    } else if (item.id === 37) {
      props.handleNovaMasina(true);
    } else if (item.id === 38) {
      props.handleNoviRadniNalog(true);
    } else if (item.id === 39) {
      props.handleShop(true);
      //  props.numberOfArticles(10);
    } else if (item.id === 40) {
      props.handleDetail(true);
    } else if (item.id === 41) {
      props.handleDodeliZaposlenima(true);
    } else if (item.id === 42) {
      props.handleDnevnik(true);
    } else if (item.id === 43) {
      props.handleBeleske(true);
    } else if (item.id === 44) {
      props.handleIzvestaji(true);
    } else if (item.id === 45) {
      props.handleKreirajDokument(true);
    } else if (item.id === 46) {
      props.handlePdfIzvestaj(true);
    } else {
      props.sendRequest(props.data);
    }
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return isMobile() ? (
    <>
      {' '}
      <SpeedDial
        ariaLabel="SpeedDial controlled open example"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {buttons.map((action) => (
          <SpeedDialAction
            key={action.title}
            icon={<i className={action.icon} />}
            tooltipTitle={action.title}
            onClick={() => handleClick(action)}
          />
        ))}
      </SpeedDial>
    </>
  ) : (
    <>
      {' '}
      <ul className="ul_buttons">
        {buttons.map((item) => {
          let className = '';
          if (item.disabled === true) {
            className = 'li_button_disabled';
          }
          return (
            <li
              key={item.title}
              className={className}
              onClick={(e) => {
                if (!item.disabled) {
                  handleClick(item);
                } else {
                  e.preventDefault();
                }
              }}
            >
              <div className="rmenu_buttons">
                <div className="rmenu_button_icon">
                  <i className={item.icon} />
                </div>
                <div className="rmenu_button_text">
                  {item.title}
                  {item.id === 39 && (
                    <span className="order_count_tooltip">
                      <span className="order_count">{item.broj}</span>
                    </span>
                  )}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default Buttons;
